import React, { useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import { GetPlayingTracks } from "../../Hooks/CurrentTracks";
import { useDispatch, useSelector } from "react-redux";
import { pauseAllTracks, playAllTracks, removeAllTracks, setConfig } from "../../Store/Slices/PlayerSlice";
import { GetPlaylistNextTrackId } from "../../Util/helpers";
import { cancelTimer } from "../../Store/Slices/TimerSlice";

const Player = () => {

    const dispatch = useDispatch();
    const tracks = GetPlayingTracks();


    const playersRef = useRef({});

    const isPlaying = useSelector((state) => state.player.isPlaying);
    const config = useSelector((state) => state.player.config);
    const currentId = config.playingId;
    const restartId = config.restartId;
    const isPlaylist = config?.type === "playlist";
    const shouldPlay = config?.shouldPlay;

    navigator.mediaSession.setActionHandler('play', () => {
        dispatch(playAllTracks());
    });

    navigator.mediaSession.setActionHandler('pause', () => {
        dispatch(pauseAllTracks());
    });

    tracks.forEach(track => {
        if (isPlaylist) {
            track.playing = (track.type === 'sounds' && track.category !== 164 && track.category !== 163 || track?.id === currentId || track?.id === shouldPlay) && isPlaying;
            track.loop = track.id === shouldPlay && config.isRepeat ? true : track.loop
        } else {
            track.playing = isPlaying;
        }
    });

    useEffect(() => {
        if (restartId && playersRef.current[restartId]) {
            playersRef.current[restartId]?.seekTo(0, "seconds"); // restart
            dispatch(setConfig({ restartId: null }));
        }
    }, [restartId]);

    useEffect(() => {
        // keep refs aligned with current tracks
        tracks.forEach(track => {
            if (!playersRef.current[track.id]) {
                playersRef.current[track.id] = React.createRef();
            }
        });

        // cleanup refs for removed tracks
        Object.keys(playersRef.current).forEach(id => {
            if (!tracks.find(t => t.id.toString() === id.toString())) {
                delete playersRef.current[id];
            }
        });
    }, [tracks]);


    // 📌 Handle track end → play next or stop
    const handleEnded = (id) => {

        // if (config?.shouldPlay === id && config.isRepeat) {
        //     playersRef?.current[id]?.seekTo(2, "seconds");
        //     return
        // }

        if (isPlaylist && config?.shouldPlay != id) {
            let nextTrackId = null;
            switch (true) {
                case config.isShuffle:
                    nextTrackId = GetPlaylistNextTrackId(tracks, config);
                    break;
                case config.isRepeat:
                    nextTrackId = GetPlaylistNextTrackId(tracks, config);
                    break;
                default:
                    nextTrackId = GetPlaylistNextTrackId(tracks, config);
                    break;
            }
            if (nextTrackId) {
                playersRef.current[nextTrackId]?.seekTo(0, "seconds"); // restart
                dispatch(setConfig({ playingId: nextTrackId })); // go to next
                dispatch(playAllTracks());  // keep playing
            } else {
                // if no next track, check if we need to restart playlist (repeat)
                if (config?.shouldPlay) {
                    dispatch(setConfig({
                        playingId: config.shouldPlay,
                        playlist_ended: true
                    }));
                    return;
                }
                dispatch(setConfig(null));  // ✅ clear currentId
                dispatch(pauseAllTracks()); // ✅ stop if last track
                dispatch(removeAllTracks()); //✅ clear all tracks
                dispatch(cancelTimer()); //✅ cancel timer if running
            }
        }
    };

    const handleProgress = (state, id) => {
        const track = tracks.find(t => t.id === id);
        const isSound = track?.type === "sounds" && track?.category !== 163 && track?.category !== 164;;
        if (!isSound) return; // only apply logic to sounds, not music or mixes
        const duration = playersRef?.current[id]?.getDuration();
        if (duration - state.playedSeconds <= 5) {
            playersRef?.current[id]?.seekTo(2, "seconds");
        }
    };


    return (
        <>
            <style>
                {`
                    .player-bar-setup { padding: 0 0 220px 0 }
                    @media (min-width: 600px) {
                        .player-bar-setup { padding: 100px 300px }
                    }
                `}
            </style>
            <div className="d-none">
                {tracks.map(track => (
                    <ReactPlayer
                        key={track.id}
                        ref={(player) => (playersRef.current[track.id] = player)}
                        url={track.url}
                        playing={track.playing}
                        volume={track.volume}
                        loop={track.loop}
                        controls={true}
                        // onPlay={() => dispatch(playAllTracks())}
                        // onPause={() => dispatch(pauseAllTracks())}
                        // onReady={() => console.log(`Track ${track.id} is ready to play`)}
                        // onBuffer={() => console.log(`Track ${track.id} is buffering...`)}
                        // onBufferEnd={() => console.log(`Track ${track.id} buffer end...`)}
                        onProgress={(state) => handleProgress(state, track.id)}
                        onEnded={() => handleEnded(track.id)}  // 🔑 playlist flow
                        width="300px"
                        height="30px"
                    />
                ))}
            </div>
        </>
    );
};

export default Player;
